import { makePieActionObjs } from "shared/imports/pieActionGenerators"
import { prependAppName } from "shared/imports/sharedHelperFunctions"

const appName = "@@a-few-of-my-favorite-things/"

const loadUserActionsObjs = makePieActionObjs("load", "userActions")
const favoriteUserActionObjs = makePieActionObjs("favorite", "userActions")
const unfavoriteUserActionObjs = makePieActionObjs("unfavorite", "userActions")
const archiveUserActionObjs = makePieActionObjs("archive", "userActions")
const clearRecentsObjs = makePieActionObjs("clearRecents", "userActions")

const loadUserActionsForProfileObjs = makePieActionObjs("load", "userActionsForProfile")
const unfavoriteProfileObjs = makePieActionObjs("unfavorite", "profile")
const favoriteProfileObjs = makePieActionObjs("favorite", "profile")

export const loadUserActionsTypes = prependAppName(appName, loadUserActionsObjs.pieDict)
export const favoriteUserActionTypes = prependAppName(appName, favoriteUserActionObjs.pieDict)
export const unfavoriteUserActionTypes = prependAppName(appName, unfavoriteUserActionObjs.pieDict)
export const archiveUserActionTypes = prependAppName(appName, archiveUserActionObjs.pieDict)
export const clearRecentsTypes = prependAppName(appName, clearRecentsObjs.pieDict)

export const loadUserActionsForProfileTypes = prependAppName(appName, loadUserActionsForProfileObjs.pieDict)
export const unfavoriteProfileTypes = prependAppName(appName, unfavoriteProfileObjs.pieDict)
export const favoriteProfileTypes = prependAppName(appName, favoriteProfileObjs.pieDict)

export const actionTypes = {
    CLEAR: `${appName}CLEAR`,
    PROFILE_IS_FAVORITED: `${appName}PROFILE_IS_FAVORITED`,
}

export default actionTypes
